export function emptyPaymentInformation() {
    return {
        methods: [],
        cardBrands: [],
        installmentProviders: [],
        digitalWallets: [],
        digitalWalletsOther: "",
        paymentDetails: "",
    };
}

export function emptyShippingCosts() {
    return {
        costCharge: "",
        flatRateAmount: "",
        freeShipping: "none",
        freeShippingMinAmount: "",
        standardDeliveryTime: "",
        sameDay: false,
        nextDay: false,
        crossBorder: false,
        crossBorderCountries: [],
        freeReturns: false,
    };
}

export function emptyShippingCarriers() {
    return {
        carriers: [],
    };
}

export function emptyDeliveryMethods() {
    return {
        methods: [],
        parcelLockerTypes: [],
        premiumServices: [],
        premiumOther: "",
        deliveryDetails: "",
    };
}

export function paymentInformationMissing(form) {
    const missing = [];
    const methods = form.methods || [];

    if (!methods.length) {
        missing.push("paymentMethod");
    }

    if (methods.includes("card_payments") && !(form.cardBrands || []).length) {
        missing.push("cardBrand");
    }

    if (methods.includes("installments") && !(form.installmentProviders || []).length) {
        missing.push("installmentProvider");
    }

    if (methods.includes("digital_wallets")) {
        const wallets = form.digitalWallets || [];

        if (!wallets.length) {
            missing.push("digitalWallet");
        }

        if (wallets.includes("other") && !String(form.digitalWalletsOther || "").trim()) {
            missing.push("digitalWalletsOther");
        }
    }

    if (!String(form.paymentDetails || "").trim()) {
        missing.push("paymentDetails");
    }

    return missing;
}

export function shippingCostsMissing(form) {
    const missing = [];

    if (!form.costCharge) {
        missing.push("shippingCostModel");
    }

    if (form.costCharge === "flat_rate" && !String(form.flatRateAmount).trim()) {
        missing.push("flatRateAmount");
    }

    if (!form.standardDeliveryTime) {
        missing.push("standardDeliveryTime");
    }

    if (form.freeShipping === "above_minimum" && !String(form.freeShippingMinAmount).trim()) {
        missing.push("freeShippingAmount");
    }

    if (form.crossBorder && !(form.crossBorderCountries || []).length) {
        missing.push("crossBorderCountries");
    }

    return missing;
}

export function shippingCarriersMissing(form) {
    return (form.carriers || []).length ? [] : ["carrier"];
}

export function deliveryMethodsMissing(form) {
    const missing = [];
    const methods = form.methods || [];

    if (!methods.length) {
        missing.push("deliveryMethod");
    }

    if (methods.includes("parcel_locker") && !(form.parcelLockerTypes || []).length) {
        missing.push("parcelLockerType");
    }

    if (!String(form.deliveryDetails || "").trim()) {
        missing.push("deliveryDetails");
    }

    return missing;
}

export function formatMissingWarning(t, missingKeys) {
    if (!missingKeys.length) {
        return "";
    }

    if (missingKeys.length === 1) {
        const direct = {
            paymentMethod: "selectPaymentMethod",
            carrier: "selectCarrier",
            deliveryMethod: "selectDeliveryMethod",
            crossBorderCountries: "crossBorderCountries",
        }[missingKeys[0]];

        if (direct) {
            return t(`pages.sellerProfile.paymentDelivery.warnings.${direct}`);
        }
    }

    const shippingOnly = missingKeys.every((key) =>
        ["shippingCostModel", "standardDeliveryTime"].includes(key)
    );

    if (shippingOnly) {
        return t("pages.sellerProfile.paymentDelivery.warnings.selectShippingCosts");
    }

    const labels = missingKeys.map((key) => t(`pages.sellerProfile.paymentDelivery.warnings.${key}`));
    const and = t("pages.sellerProfile.paymentDelivery.warnings.and");
    let list = labels[0];

    if (labels.length === 2) {
        list = `${labels[0]} ${and} ${labels[1]}`;
    } else if (labels.length > 2) {
        list = `${labels.slice(0, -1).join(", ")} ${and} ${labels[labels.length - 1]}`;
    }

    return t("pages.sellerProfile.paymentDelivery.warnings.addToSave", { list });
}

export function toggleSlug(list, slug, on) {
    const index = list.indexOf(slug);

    if (on && index === -1) {
        list.push(slug);
        return;
    }

    if (!on && index >= 0) {
        list.splice(index, 1);
    }
}

export const PAYMENT_DELIVERY_EMPTY = {
    "payment-information": emptyPaymentInformation,
    "shipping-costs": emptyShippingCosts,
    "shipping-carriers": emptyShippingCarriers,
    "delivery-methods": emptyDeliveryMethods,
};

export const PAYMENT_DELIVERY_COMPLETE = {
    "payment-information": (payload) => paymentInformationMissing(payload).length === 0,
    "shipping-costs": (payload) => shippingCostsMissing(payload).length === 0,
    "shipping-carriers": (payload) => shippingCarriersMissing(payload).length === 0,
    "delivery-methods": (payload) => deliveryMethodsMissing(payload).length === 0,
};

export function isSectionComplete(sectionId, payload) {
    const check = PAYMENT_DELIVERY_COMPLETE[sectionId];
    return check ? check(payload) : false;
}

export function emptyPaymentDelivery() {
    return Object.fromEntries(
        Object.entries(PAYMENT_DELIVERY_EMPTY).map(([sectionId, factory]) => [
            sectionId,
            {
                payload: factory(),
                isComplete: false,
            },
        ])
    );
}
